/**
 * Enum for fiscal docs provider type.
 * @readonly
 * @enum {String} FiscalDocsProviderTypeEnum
 */

const FiscalDocsProviderTypeEnum = {
  CLOUD        : 'cloud',
  LOCAL        : 'local',
  CASH_REGISTER: 'cash_register',
  TAX_REGISTER : 'tax_register',
  NONE         : ''
}

export default FiscalDocsProviderTypeEnum
